import { useState } from 'react';
import { useMountEffect } from '@client/hooks/utils.hooks';

const loadScript = (src: string, position: HTMLHeadElement, id: string, callback: () => void) => {
  if (position) {
    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('id', id);
    script.src = src;
    position.appendChild(script);

    script.onload = callback;
  }
};

export const useGoogleMaps = (loadGoogleScriptExternally?: boolean) => {
  const [loaded, setLoaded] = useState(loadGoogleScriptExternally);

  useMountEffect(() => {
    if (typeof window !== 'undefined' && !loaded && !loadGoogleScriptExternally) {
      if (!document.querySelector('#google-maps')) {
        loadScript(
          `https://maps.googleapis.com/maps/api/js?key=${process.env.GOOGLE_MAPS_API_KEY}&libraries=places`,
          document.querySelector('head'),
          'google-maps',
          () => setLoaded(true),
        );
      } else {
        setLoaded(true);
      }
    }
  });

  return loaded;
};
